<div class="my-3 my-md-5">
    <div class="container">
        <div class="form-group">
            <div class="row">
                <div class="col-sm-6">
                    <h2 class="page-title">
                        <span>Member's Transaction</span>
                    </h2>
                </div>
                <div class="col-sm-6 ">
                    <a  routerLink="/members" class="btn btn-success ml-2 pull-right">
                        <i class="fa fa-angle-double-left" aria-hidden="true"></i> Back
                    </a>
                </div>
            </div>
        </div>
        <div class="card">
            <form [formGroup]="transactionForm" (submit)="saveTransactionData()">
            	<div class="card-body">
		            <div class="container-fluid p-3">
                        <div class="form-group">
		                    <div class="row">
		                        <div class="col-sm-6">
		                            <div class="form-group">
		                                <label class="form-label">Name <span class="text-danger">*</span></label>
		                                <input class="form-control" formControlName="name" placeholder="Name" />
		                                <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        	<div *ngIf="f.name.errors.required">Name is required</div>
                                    	</div>
		                            </div>
		                        </div>
                                <div class="col-sm-6">
		                            <div class="form-group">
		                                <label class="form-label">Mobile <span class="text-danger">*</span></label>
		                                <input class="form-control" formControlName="mobile" placeholder="Mobile" />
		                                <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                        	<div *ngIf="f.mobile.errors.required">Mobile is required</div>
                                            <div *ngIf="!f.mobile.valid && f.mobile.value">Invalid Mobile number format</div>
                                    	</div>
		                            </div>
		                        </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
		                            <div class="form-group">
		                                <label class="form-label">Email</label>
		                                <input class="form-control" formControlName="email" placeholder="Email" />
		                            </div>
		                        </div>
                                <div class="col-sm-6">
		                            <div class="form-group">
		                                <label class="form-label">City</label>
		                                <mat-select placeholder="Select City" formControlName="city_id" (click)="setSearchValue('city')">
										<input class="mySearchInput"
										#citySearch focused="'true'" type="text"
										(keyup)="searchOnSelect($event.target.value, 'city')"
										(keydown)="$event.stopPropagation()" autocomplete="off"
										placeholder="Search"
										id="citySearch">
		                                    <mat-option>Select City</mat-option>
		                                    <mat-option [value]="city.city_id" *ngFor="let city of cities">{{city.name}}</mat-option>
		                                </mat-select>
		                            </div>
		                        </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
		                            <div class="form-group">
		                                <label class="form-label">Package Type <span class="text-danger">*</span></label>
		                                <mat-select placeholder="Select Package Type" formControlName="package_type">
		                                    <mat-option>Select Package Type</mat-option>
		                                    <mat-option [value]="ptype.id" *ngFor="let ptype of package_type">{{ptype.plan_name}}</mat-option>
		                                </mat-select>
                                        <div *ngIf="submitted && f.package_type.errors" class="invalid-feedback">
                                        	<div *ngIf="f.package_type.errors.required">Package Type is required</div>
                                    	</div>
		                            </div>
		                        </div>
                                <div class="col-sm-6">
		                            <div class="form-group">
		                                <label class="form-label">Payment Mode <span class="text-danger">*</span></label>
		                                <mat-select placeholder="Select Payment Mode" formControlName="payment_mode">
		                                    <mat-option>Select Payment Mode</mat-option>
		                                    <mat-option [value]="pmode.value" *ngFor="let pmode of payment_mode">{{pmode.name}}</mat-option>
		                                </mat-select>
                                        <div *ngIf="submitted && f.payment_mode.errors" class="invalid-feedback">
                                        	<div *ngIf="f.payment_mode.errors.required">Payment Mode is required</div>
                                    	</div>
		                            </div>
		                        </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
		                                <label class="form-label">Order ID</label>
		                                <input class="form-control" formControlName="order_id" placeholder="Order ID" />
		                            </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
		                                <label class="form-label">Payment/Transaction ID</label>
		                                <input class="form-control" formControlName="payment_id" placeholder="Payment/Transaction ID" />
		                            </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
		                                <label class="form-label">Amount</label>
		                                <input class="form-control" formControlName="amount" placeholder="Amount" />
		                            </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Transaction Date/Time <span class="text-danger">*</span></label>
                                        <input type="datetime-local" formControlName="transaction_date"  class="form-control"/>
                                        <div *ngIf="submitted && f.transaction_date.errors" class="invalid-feedback">
                                            <div *ngIf="f.transaction_date.errors.required">Transaction Date is required</div>
                                        </div>
		                            </div>
                                </div>
                            </div>

							<div class="row">
                                <div class="col-sm-6">
									<div class="form-group">
										<label class="form-label">Select User</label>
										<mat-select placeholder="Select User" formControlName="memberBd" (click)="setSearchValue('bd')">
										<input class="mySearchInput"
										#bdSearch focused="'true'" type="text"
										(keyup)="searchOnSelect($event.target.value, 'bd')"
										(keydown)="$event.stopPropagation()" autocomplete="off"
										placeholder="Search"
										id="bdSearch">
											<mat-option>Select User</mat-option>
											<mat-option [value]="bd.id" *ngFor="let bd of memberBds">{{bd.name}}<span> ( {{bd.email}} )</span></mat-option>
										</mat-select>
									</div>
								</div>
							</div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button  type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> 
                        <span>Create Transaction</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>